import { createFileRoute } from '@tanstack/react-router';

import { SecurityPage, twoFactorStatusQueryOptions } from '@/features/auth';

/** Every signed-in staff member manages their own two-factor; no permission gate. */
export const Route = createFileRoute('/_authed/_active/account/security')({
  staticData: { crumb: 'common:nav.security', tours: ['account.security'] },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...twoFactorStatusQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: SecurityPage,
});
